import React from 'react';
import { IPublishApprovalFlowModel } from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/publishApprovalFlowModel';
import ApprovalList from '../ApprovalList';

interface Props {
  isMobile: boolean;
  filteredFlowModels: IPublishApprovalFlowModel[];
}

const SentForApprovalList: React.FC<Props> = ({
  isMobile,
  filteredFlowModels
}) => {
  return (
    <ApprovalList
      isMobile={isMobile}
      filteredFlowModels={filteredFlowModels}
      roleLabel="Approver"
      emptyStateData={{
        summaryText: 'No flow models were sent for approval',
        bodyText: 'You haven’t submitted any flow models for approval'
      }}
    />
  );
};

export default SentForApprovalList;
